import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import RoofingSpecialistsHero from "./sections/RoofingSpecialistsHero";
import VarFilosofi from "./sections/VarFilosofi";
import FullstandigtGalleri from "./sections/FullstandigtGalleri";
import OurQualitySeal from "./sections/OurQualitySeal";
import SizeSelector from "./sections/SizeSelector";
import Process from "./sections/Process";
import CostGuide from "./sections/CostGuide";
import Rotdeduction from "./sections/Rotdeduction";
import Faq from "./sections/Faq";
import Servicearea from "./sections/Servicearea";
import RedoAttSynasITrafiken from "./sections/RedoAttSynasITrafiken";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <RoofingSpecialistsHero />
      <VarFilosofi />
      <Process />
      <FullstandigtGalleri />
      <OurQualitySeal />
      <SizeSelector />
      <CostGuide />
      <Rotdeduction />
      <Faq />
      <Servicearea />
      <RedoAttSynasITrafiken />
      <Footer />
    </div>;
}